import { useAuthStatus } from '@/hooks/use-auth-status';
import { Redirect } from 'expo-router';
import React from 'react';

export default function Index() {
  const authStatus = useAuthStatus();

  if (authStatus === 'verified') {
    return <Redirect href={{ pathname: '/(tabs)/activity' }} />;
  }

  if (authStatus === 'loggedOut') {
    return <Redirect href={{ pathname: '/(auth)/login' }} />;
  }

  // Loading or unverified -- ProtectedRoutes handles these
  return null;
}
